<script lang="ts">
	//UI
	import { DefaultLoading, LeftRight, Popper } from "@hitit/new_ui";
	import PointEarnedModal from "./PointEarnedModal.svelte";
	import AreYouSure from "@hitit/hub/src/v7/components/common/AreYouSure.svelte";
	//Image
	//Utils
	import { t, api } from "@hitit/hub/src/stores";
	import { popup } from "@hitit/hub/src/v7/store";
	import { createEventDispatcher } from "svelte";
	//Type
	import type { OrderData, RewardDTO } from "@hitit/api";
	import { navigate } from "svelte-routing";
	import { processingDate } from "@hitit/hub/src/v7/utils";

	export let orderUnwrapDTO: OrderData;

	const dispatch = createEventDispatcher();
	const description = `고객님의 성별 및 나이대를 선택하여
	고객 관리를 효율적으로 할 수 있습니다`;

	let earnedRewardDto: RewardDTO | null = null;
	let redeemedRewardDto: RewardDTO | null = null;
	let noEarnedItems: (string | undefined)[] = [];
	let redeemedSelect = "redeemed";
	let pointEarnedModal = false;
	let rewardData: string = "";

	function pointEarnedModalOpenHandler(reward: number) {
		pointEarnedModal = true;
		rewardData = String(reward);
		document.body.style.overflow = "hidden";
		document.body.style.touchAction = "none";
	}

	function pointEarnedModalCloseHandler() {
		pointEarnedModal = false;
		document.body.style.overflow = "unset";
		document.body.style.touchAction = "unset";
	}

	function updateOrder(orderDTO: OrderData) {
		dispatch("EARNED_CANCEL_UPDATE_ORDER", orderDTO);
	}

	async function rewardCancel(rewardId: string) {
		try {
			await $api.postCancelReward(
				orderUnwrapDTO.storeid!,
				rewardId,
				"웹 적립 취소"
			);
			const r = await $api.getOrder(
				orderUnwrapDTO.storeid!,
				orderUnwrapDTO.id!
			);
			updateOrder(r.data.orderDTO);
		} catch (e) {
			console.log("e", e);
		}
	}

	function pointRewardCancelHandler() {
		$popup = {
			component: AreYouSure,
			props: {
				textTranslation: `고객번호 ${earnedRewardDto?.userIdentity}</br> 포인트 적립을 취소하시겠습니까?`,
				subText: "취소시 해당 고객에게 메시지가 발송됩니다",
				accept: async () => {
					await rewardCancel(orderUnwrapDTO.orderRewardDTO?.earned?.id || "");
					$popup = undefined;
				},
				cancel: () => ($popup = undefined),
			},
		};
	}

	async function loadData(orderUnwrapDTO: OrderData) {
		earnedRewardDto = null;
		redeemedRewardDto = null;
		try {
			if (orderUnwrapDTO.orderRewardDTO?.redeemed?.id) {
				redeemedRewardDto = (
					await $api.getPointReward(
						orderUnwrapDTO.storeid!,
						orderUnwrapDTO.orderRewardDTO.redeemed.id
					)
				).data.rewardDTO;
			}

			if (orderUnwrapDTO.orderRewardDTO?.earned?.id) {
				earnedRewardDto = (
					await $api.getPointReward(
						orderUnwrapDTO.storeid!,
						orderUnwrapDTO.orderRewardDTO.earned.id
					)
				).data.rewardDTO;
			}
			if (orderUnwrapDTO.itemDTOs) {
				noEarnedItems = orderUnwrapDTO.itemDTOs?.map((v, i) => {
					if (i !== 0) {
						return ` ${v.name}`;
					}
					return v.name;
				});
			}
		} catch (e) {
			console.log(e);
		}
	}

	function makeUseType(rewardStatus: string) {
		if (rewardStatus === "REDEEMED") {
			return "- 사용";
		}
		if (rewardStatus === "EARNED") {
			return "+ 적립";
		}
	}

	$: loadData(orderUnwrapDTO);
	$: console.log("earnedRewardDto", earnedRewardDto);
	$: console.log("redeemedRewardDto", redeemedRewardDto);
	$: console.log("rewardData", rewardData);
	$: console.log("orderUnwrapDTO", orderUnwrapDTO);
</script>

{#if pointEarnedModal}
	<PointEarnedModal
		on:EARNED_UPDATE_ORDER
		orderData={orderUnwrapDTO}
		rewardData={rewardData}
		pointEarnedModalCloseHandler={pointEarnedModalCloseHandler}
	/>
{/if}
<div class="container" t-id="PointTab">
	{#await loadData(orderUnwrapDTO)}
		<div class="loading">
			<DefaultLoading />
		</div>
	{:then loadData}
		{#if redeemedRewardDto}
			{#if orderUnwrapDTO.orderStatus === "CLOSED"}
				<div class="left-card card">
					<div class="use-type-box box">
						<span class="title">{$t("global.point.pointColumn.type")}</span>
						<span
							class="type-content"
							class:pointUse={redeemedRewardDto.rewardStatus === "REDEEMED"}
							>{makeUseType(redeemedRewardDto.rewardStatus)}</span
						>
					</div>
					<div class="use-point-box box">
						<span class="title">{$t("global.point.usedPoint")}</span>
						<span class="content">{`${redeemedRewardDto.reward}P`}</span>
					</div>
					{#if earnedRewardDto}
						<div class="use-type-box box">
							<span
								class="title"
								class:pointEarned={earnedRewardDto.rewardStatus === "EARNED"}
								>{$t("global.point.pointColumn.type")}</span
							>
							<span class="type-content"
								>{makeUseType(earnedRewardDto.rewardStatus)}</span
							>
						</div>
						<div class="earned-point-box box">
							<span class="title">{$t("hub.order.point.earned_point")}</span>
							<span class="content">{`+${earnedRewardDto.reward}P`}</span>
						</div>
						<div class="earned-item-box box">
							<span class="title"
								>{$t("hub.order.point.products_eligible_for_point")}</span
							>
							<span class="content">{noEarnedItems || ""}</span>
						</div>
						<div
							class="point-cancel-widget point-widget"
							on:click={pointRewardCancelHandler}
						>
							<span>{$t("hub.order.point.cancel_point_accumulation")}</span>
						</div>
					{:else if orderUnwrapDTO.orderRewardDTO?.earned?.reward !== 0}
						<div
							class="point-earned-widget point-widget"
							on:click={() =>
								pointEarnedModalOpenHandler(
									orderUnwrapDTO.orderRewardDTO?.earned?.reward || 0
								)}
						>
							<span>{$t("hub.order.point.point_accumulation")}</span>
						</div>
					{/if}
				</div>
			{/if}
			<div class="right-card card">
				<!-- 현상황에서 사용/적립 탭을 나눌필요가 없음 앱기준으로 포인트를 사용하고 나머지 금액 포인트 적립을 안할 시 포인트 적립만 나옴. -->
				<!-- <div class="header">
					<div
						class:redeemed={redeemedSelect === "redeemed"}
						on:click={() => (redeemedSelect = "redeemed")}
					>
						<span>사용</span>
					</div>
					<div
						class:earned={redeemedSelect === "earned"}
						on:click={() => (redeemedSelect = "earned")}
					>
						<span>적립</span>
					</div>
				</div> -->
				<div class="info-wrapper">
					<div class="first-box">
						<div class="user-phone-box box left">
							<span class="title"
								>{$t("hub.order.point.cumstomer_phone_number")}</span
							>
							<span class="content"
								>{redeemedSelect === "redeemed"
									? redeemedRewardDto.userIdentity
									: earnedRewardDto?.userIdentity}</span
							>
						</div>
						<div class="created box right">
							<span class="title">{$t("mbr.search.createddate")}</span>
							<span class="content"
								>{processingDate(
									redeemedSelect === "redeemed"
										? redeemedRewardDto.createdDate
										: earnedRewardDto?.createdDate,
									"yyyy.MM.DD"
								)}</span
							>
						</div>
					</div>
					<div class="second-box">
						<!-- 추후 api 나오면 개발 -->
						<!-- <div class="current-point-box box left">
							<span class="title"
								>{$t("global.customerInfo.activateTotalPoint")}</span
							>
							<span class="content">15,000P</span>
						</div> -->
						<!-- <div class="total-order box right">
							<span class="title">{$t("hub.order.point.total_order")}</span>
							<span class="content">25회</span>
						</div> -->
					</div>
					<!-- 추후 api 나오면 개발 -->
					<!-- <div class="third-box">
						<div class="gender box left">
							<div class="popper-box">
								<span class="title">{$t("hub.profile.gender")}</span>
								<div class="popper">
									<Popper description={description} fill={"#bcbfc3"} />
								</div>
							</div>
							<div class="widget">
								<div class="small-btn"><span>남성</span></div>
								<div class="small-btn"><span>여성</span></div>
								<div class="small-btn"><span>기타</span></div>
							</div>
						</div>
						<div class="age box right">
							<div class="popper-box">
								<span class="title">{$t("hub.order.point.age")}</span>
								<div class="popper">
									<Popper description={description} fill={"#bcbfc3"} />
								</div>
							</div>
							<div class="widget">
								<div class="small-btn"><span>10대</span></div>
								<div class="small-btn"><span>2-30대</span></div>
								<div class="small-btn"><span>4-50대</span></div>
								<div class="small-btn"><span>60대 이상</span></div>
							</div>
						</div>
					</div> -->
					<div
						class="move-user-list"
						on:click={() =>
							navigate(`/store/${orderUnwrapDTO.storeid}/earning/client`)}
					>
						<span>{$t("hub.order.point.move_customer_list")}</span>
						<LeftRight direction={"right"} />
					</div>
				</div>
			</div>
		{:else}
			{#if orderUnwrapDTO.orderStatus === "CLOSED"}
				<div class="left-card card">
					{#if earnedRewardDto}
						<div class="use-type-box box">
							<span
								class="title"
								class:pointEarned={earnedRewardDto.rewardStatus === "EARNED"}
								>{$t("global.point.pointColumn.type")}</span
							>
							<span class="type-content"
								>{makeUseType(earnedRewardDto.rewardStatus)}</span
							>
						</div>
						<div class="earned-point-box box">
							<span class="title">{$t("hub.order.point.earned_point")}</span>
							<span class="content">{`+${earnedRewardDto.reward}P`}</span>
						</div>
					{:else}
						<div class="earned-point-box box">
							<span class="title">{$t("hub.order.point.point_can_earned")}</span>
							<span class="content"
								>{`+ ${orderUnwrapDTO.orderRewardDTO?.earned?.reward}P`}</span
							>
						</div>
					{/if}
					<div class="earned-item-box box">
						<span class="title"
							>{$t("hub.order.point.products_eligible_for_point")}</span
						>
						<span class="content">{noEarnedItems || ""}</span>
					</div>
					{#if earnedRewardDto}
						<div
							class="point-cancel-widget point-widget"
							on:click={pointRewardCancelHandler}
						>
							<span>{$t("hub.order.point.cancel_point_accumulation")}</span>
						</div>
					{:else if orderUnwrapDTO.orderRewardDTO?.earned?.reward !== 0}
						<div
							class="point-earned-widget point-widget"
							on:click={() =>
								pointEarnedModalOpenHandler(
									orderUnwrapDTO.orderRewardDTO?.earned?.reward || 0
								)}
						>
							<span>{$t("hub.order.point.point_accumulation")}</span>
						</div>
					{/if}
				</div>
			{/if}
			{#if earnedRewardDto}
				<div class="right-card card">
					<div class="info-wrapper">
						<div class="first-box">
							<div class="user-phone-box box left">
								<span class="title"
									>{$t("hub.order.point.cumstomer_phone_number")}</span
								>
								<span class="content">{earnedRewardDto.userIdentity}</span>
							</div>
							<div class="created box right">
								<span class="title">{$t("mbr.search.createddate")}</span>
								<span class="content"
									>{processingDate(
										earnedRewardDto.createdDate,
										"yyyy.MM.DD"
									)}</span
								>
							</div>
						</div>
						<div class="second-box">
							<!-- 추후 api 개발후 작업 -->
							<!-- <div class="current-point-box box left">
								<span class="title"
									>{$t("global.customerInfo.activateTotalPoint")}</span
								>
								<span class="content">{earnedRewardDto.reward}P</span>
							</div> -->
							<!-- <div class="total-order box right">
								<span class="title">{$t("hub.order.point.total_order")}</span>
								<span class="content">25회</span>
							</div> -->
						</div>
						<!-- 추후 api 개발후 작업 -->
						<!-- <div class="third-box">
							<div class="gender box left">
								<div class="popper-box">
									<span class="title">{$t("hub.profile.gender")}</span>
									<div class="popper">
										<Popper description={description} fill={"#bcbfc3"} />
									</div>
								</div>
								<div class="widget">
									<div class="small-btn"><span>남성</span></div>
									<div class="small-btn"><span>여성</span></div>
									<div class="small-btn"><span>기타</span></div>
								</div>
							</div>
							<div class="age box right">
								<div class="popper-box">
									<span class="title">{$t("hub.order.point.age")}</span>
									<div class="popper">
										<Popper description={description} fill={"#bcbfc3"} />
									</div>
								</div>
								<div class="widget">
									<div class="small-btn"><span>10대</span></div>
									<div class="small-btn"><span>2-30대</span></div>
									<div class="small-btn"><span>4-50대</span></div>
									<div class="small-btn"><span>60대 이상</span></div>
								</div>
							</div>
						</div> -->
						<div
							class="move-user-list"
							on:click={() =>
								navigate(`/store/${orderUnwrapDTO.storeid}/earning/client`)}
						>
							<span>{$t("hub.order.point.move_customer_list")}</span>
							<LeftRight direction={"right"} />
						</div>
					</div>
				</div>
			{/if}
		{/if}
	{/await}
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		gap: 20px;
		/* padding: 10px; */
		.card {
			display: flex;
			align-items: center;
			background-color: white;
			border-radius: 5px;
		}
		.box {
			display: flex;
			flex-direction: column;
			gap: 10px;

			.title {
				@include appleAdjustTextForSize(14);
				color: #46474b;
			}
		}
		.left-card {
			display: flex;
			flex-direction: column;
			/* width: 100%; */
			height: fit-content;
			align-items: baseline;
			gap: 20px;
			padding: 10px;
			.use-type-box {
				.pointUse {
					color: #e54848;
				}
				.pointEarned {
					color: #6591fa;
				}
			}

			.point-widget {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 40px;
				border-radius: 25px;
				cursor: pointer;

				span {
					@include appleAdjustTextForSize(16);
					font-weight: 400;
					color: white;
				}
			}
			.point-cancel-widget {
				background-color: #f66d6c;
			}
			.point-earned-widget {
				background-color: #6591fa;
			}
		}
		.right-card {
			display: flex;
			flex-direction: column;
			/* width: 100%; */
			/* height: fit-content; */
			.header {
				display: flex;
				width: 100%;
				div {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 50%;
					height: 54px;
					cursor: pointer;

					&.redeemed {
						border-bottom: 2px solid #3c68d6;
					}
					&.earned {
						border-bottom: 2px solid #3c68d6;
					}
				}
			}
			.info-wrapper {
				display: flex;
				flex-direction: column;
				width: -webkit-fill-available;
				gap: 20px;
				padding: 10px;
				height: 100%;

				.move-user-list {
					display: flex;
					justify-content: center;
					align-items: center;
					gap: 13px;
					width: 100%;
					height: 40px;
					border: 1px solid #d8d9df;
					border-radius: 20px;
					cursor: pointer;
					margin-top: auto;

					span {
						@include appleAdjustTextForSize(16);
						font-weight: 400;
						color: #46474b;
					}
				}
			}
			.left {
				width: 40%;
			}
			.right {
				width: 60%;
			}
			.first-box {
				display: flex;
				flex-direction: column;
				flex-wrap: wrap;
				gap: 20px;
			}
			.second-box {
				display: flex;
				flex-direction: column;
				flex-wrap: wrap;
				gap: 20px;
			}
			.third-box {
				display: flex;
				flex-direction: column;
				flex-wrap: wrap;
				gap: 20px;

				.popper-box {
					display: flex;
					align-items: center;
					gap: 6px;
					.popper {
						width: 20px;
						height: 20px;
						font-size: 0.875rem;
						color: #46474b;
					}
				}

				.age {
					.widget {
						.small-btn {
							&:nth-child(2) {
								min-width: 87px;
							}
							&:nth-child(2) {
								min-width: 87px;
							}

							&:nth-child(4) {
								min-width: 107px;
							}
						}
					}
				}

				.widget {
					display: flex;
					min-width: 280px;
					flex-wrap: wrap;
					gap: 10px;

					.small-btn {
						display: flex;
						justify-content: center;
						align-items: center;
						border: 1px solid #bcbfc3;
						border-radius: 16px;
						height: 32px;
						padding: 0px 15px;
					}
				}
			}
		}
	}
	@include DesktopSize {
		.container {
			flex-direction: row;
			.box {
				.title {
					@include appleAdjustTextForSize(16, false);
				}
			}
			.left-card {
				width: 40%;
				gap: 30px;
				padding: 20px;

				.point-widget {
					height: 50px;

					span {
						@include appleAdjustTextForSize(16, false);
					}
				}
			}
			.right-card {
				width: 60%;
				.info-wrapper {
					padding: 20px;

					.move-user-list {
						height: 50px;
						border-radius: 25px;

						span {
							@include appleAdjustTextForSize(16, false);
						}
					}
				}
				.first-box {
					display: flex;
					flex-direction: row;
					gap: unset;
				}
				.second-box {
					display: flex;
					flex-direction: row;
					gap: unset;
				}
				.third-box {
					display: flex;
					flex-direction: row;
					gap: unset;

					.widget {
						min-width: unset;
					}
				}
			}
		}
	}
</style>
